// This file was automatically generated from ptdata.addendums.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.addendums');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.reports');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.addendums.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('\t<p class="el8FeedItemHeader"><span class="el8TagItem mr5">Addendum</span> <a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.item.docId), '">');
  el8.template.ptdata.reports.noteSummary(opt_data.referencedDoc, output);
  output.append('</a></p><p>', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item.text)) : soy.$$escapeHtml(opt_data.item.text)), '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.addendums.reportSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="', (opt_data.allowActions != false) ? 'el8ItemHover ' : '', 'el8BulletText">', (opt_data.allowActions != false) ? '<div class="el8ItemButtonContainer"><button type="button" class="addToNoteTrigger el8ItemButton" _fid="' + soy.$$escapeHtml(opt_data.item.feedItemId) + '">Ref HPI</button></div>' : '', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.item.text)) : soy.$$escapeHtml(opt_data.item.text)), ' <span class="el8SystemText">-- ', soy.$$escapeHtml(opt_data.item.signUserName), ', ', (soy.$$escapeHtml(opt_data.item.signDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.item.signDate)) : ''), '</span></li>');
  if (!opt_sb) return output.toString();
};
